import React from 'react'

const Settings = () => {
  return (
    <div className="text-6xl font-bold">
        Settings
    </div>
  )
}

export default Settings